import { getTestIdProp } from '@ab-core/testing';
import type { TextProps } from '@ab-core/text';
import Text, { FontTypes } from '@ab-core/text';
import type { FC } from 'react';
import React from 'react';
import type { ScalableStyle } from '../../scalableStyles';
import { StyledIdsContainer } from './styled';

export type IdsContainerStyleType = ScalableStyle<{
    customerArticleNumber: boolean;
    articleNumber: boolean;
    ean: boolean;
}>;

export type IdsContainerProps = {
    articleNumber?: string;
    ean?: string;
    customerArticleNumber?: string;
};

const textStyle: TextProps = {
    color: 'inherit',
    type: FontTypes.Subtitle
};

export const IdsContainer: FC<IdsContainerProps & IdsContainerStyleType> = (props) => {
    const { articleNumber, ean, customerArticleNumber, scalableStyle } = props;

    if (!scalableStyle?.articleNumber && !scalableStyle?.ean && !scalableStyle?.customerArticleNumber) {
        return <></>;
    }

    return (
        <StyledIdsContainer>
            {articleNumber && scalableStyle?.articleNumber && (
                <Text {...textStyle}>
                    Artikel: <span {...getTestIdProp('product-card-sku')}>{articleNumber}</span>
                </Text>
            )}
            {ean && scalableStyle?.ean && (
                <Text {...getTestIdProp('product-card-ean')} {...textStyle}>
                    EAN: {ean}
                </Text>
            )}
            {customerArticleNumber && scalableStyle?.customerArticleNumber && (
                <Text {...textStyle} {...getTestIdProp('product-card-customer-article-number')}>
                    Ku. Art. Nr.: {customerArticleNumber}
                </Text>
            )}
        </StyledIdsContainer>
    );
};
